import React, { useState } from "react";
import { Button, Col, Form, message, Modal, Row, Upload } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FormBox, InputBox } from "../../../../components/AntdAddons";
import { UploadOutlined } from "@ant-design/icons";
import {
  dataToFormDataConverter,
  Notification,
} from "../../../../config/Global";
import { CONSTANT } from "../../../../config/Constant";
import { AppDispatch } from "../../../../store/app";
import { useDispatch } from "react-redux";
import { FixCSV } from "../../../../store/SIMManagementSlice";
import SVGIcon from "../../../../utils/SVGIcon";

const CsvUpload: React.FC<any> = (props) => {
  const { visible, close, getList } = props;
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [wrongCSV, setWrongCSV] = useState<boolean>(false);
  const [remainingData, setRemainingData] = useState<any>([]);
  const [wrongFileds, setWrongFileds] = useState([]);
  // const [selectedValues, setSelectedValues] = useState({});
  const [csvId, setCsvId] = useState();
  const csvPath = "/assets/sim_add_example.csv";
  const dispatch: AppDispatch = useDispatch();
  const authToken = localStorage.getItem("token");
  var myHeaders = new Headers();
  myHeaders.append("Authorization", authToken ? authToken : "");
  const csvUploaded = (data: any) => {
    dispatch(FixCSV(data))
      .then((res: any) => {
        console.log(res);
        handleClose();
      })
      .catch((e: any) => {
        console.warn(e);
      });
  };
  const handleSubmit = async (data: any) => {
    if (wrongCSV) {
      let mapField: { [key: string]: any } = {}; // Declare mapField as a mutable object
      const keys = Object.keys(data);
      const values = Object.values(data);
      data.id = csvId;
      keys.forEach((key, index) => {
        mapField[key] = values[index];
      });

      data.mapField = mapField;
      keys.forEach((key) => {
        delete data[key];
      });
      csvUploaded(data);
    } else {
      const formData = dataToFormDataConverter(data);
      if (fileList.length > 0) {
        formData.append("uploadFile", fileList[0]?.originFileObj);
      }
      try {
        const response = await fetch(`${CONSTANT.BASE_URL}/sim/import`, {
          method: "POST",
          body: formData,
          headers: myHeaders,
        });
        const resData: any = await response.json();

        if (resData?.data.nonMatches?.length > 0) {
          const singleString = resData?.data.nonMatches.join(", ");
          Notification.error({
            message: `"${singleString}" field(s) are mismatched.`,
          });
          setWrongCSV(true);
          setCsvId(resData?.data.CSV_id);
          setWrongFileds(resData?.data.nonMatches);
          setRemainingData(resData.data.remaining);
        } else {
          const payload = {
            id: resData?.data.CSV_id,
            mapField: {},
          };
          csvUploaded(payload);
          handleClose();
        }

        // if (response.ok) {
        //   setLoading(false);
        //   Notification.success({
        //     message: "File uploaded successfully.",
        //   });
        // }
      } catch (error) {
        setLoading(false);
        console.error("Error uploading file:", error);
        Notification.error({
          message: "File upload failed.",
        });
      }
    }
  };

  const handleClose = () => {
    getList();
    close();
    setFileList([]);
    form.resetFields();
    setWrongCSV(false);
    setRemainingData([]);
    setWrongFileds([]);
  };
  const resetField = () => {
    setFileList([]);
    const updatedOptions = remainingData.map((option: any) => ({
      ...option,
      disabled: false,
    }));
    setRemainingData(updatedOptions);
    form.resetFields();
  };
  const handleFileChange = ({ fileList }: any) => {
    if (fileList.length) {
      const isLt10MB = fileList[0].size / 1024 / 1024 <= 5;
      const acceptedFileTypes = ["text/csv"];
      if (!isLt10MB || !acceptedFileTypes.includes(fileList[0].type)) {
        if (!isLt10MB) {
          message.error(`${fileList[0].name} is larger than 5MB`);
          return Upload.LIST_IGNORE;
        }
        if (!acceptedFileTypes.includes(fileList[0].type)) {
          message.error(`${fileList[0].name} is not a valid file type`);
          return Upload.LIST_IGNORE;
        }
        setFileList([]);
        form.setFieldsValue({ upload_csv: [] });
      } else {
        setFileList(fileList);
        form.setFieldsValue({ upload_csv: fileList.length ? fileList : null });
      }
    } else {
      setFileList([]);
      form.setFieldsValue({ upload_csv: [] });
    }
  };
  const handleDownload = () => {
    const fileName = "example.csv";
    const link = document.createElement("a");
    link.download = fileName;
    link.href = csvPath;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handelDeSelect = (selectedValue: string) => {
    const value = form.getFieldValue(selectedValue);
    setRemainingData((prevData) =>
      prevData.map((option) =>
        option.value === value ? { ...option, disabled: false } : option
      )
    );
  };
  const onChange = () => {
    const fieldValues = form.getFieldsValue();
    const selectedValues = Object.values(fieldValues);

    const updatedData = remainingData.map((item: any) => ({
      ...item,
      disabled: selectedValues.includes(item.value),
    }));

    setRemainingData(updatedData);
  };

  return (
    <>
      <Modal
        open={visible}
        destroyOnClose
        width={700}
        onCancel={handleClose}
        closeIcon={<FontAwesomeIcon icon={faTimes} />}
        footer={false}
        className="addModal"
        title={"Bulk Add"}
      >
        <FormBox
          className="filterForm"
          form={form}
          onFinish={handleSubmit}
          validateTrigger={["onBlur", "onInput"]}
          autoComplete="off"
        >
          {!wrongCSV && (
            <Row gutter={[20, 0]} align={"top"}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="upload_csv"
                  label="Upload CSV"
                  extra="Note: Upload CSV file upto 10 MB only."
                  rules={
                    wrongCSV
                      ? [{ required: false }]
                      : [
                          {
                            required: true,
                            message: "Please upload a CSV file",
                          },
                        ]
                  }
                >
                  <Upload
                    beforeUpload={() => false}
                    maxCount={1}
                    onChange={handleFileChange}
                    accept="text/csv"
                    listType="text"
                    fileList={fileList}
                  >
                    <Button loading={loading} icon={<UploadOutlined />}>
                      Upload
                    </Button>
                    <div className="mb-10"></div>
                  </Upload>
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item label="Download Sample File">
                  <Button
                    onClick={handleDownload}
                    icon={<UploadOutlined style={{ rotate: "180deg" }} />}
                  >
                    Sample CSV
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          )}
          {wrongCSV && (
            <Row gutter={30}>
              {wrongFileds.map((item: any, index: number) => {
                return (
                  <Col key={index} xs={24} md={12}>
                    <InputBox.Select
                      label={item}
                      name={item}
                      placeholder={item}
                      allowClear
                      onChange={() => onChange()}
                      // onDeselect={(e) => handelDeSelect(e)}
                      // onChange={(e) => handelDeSelect(e)}
                      onClear={() => handelDeSelect(item)}
                      options={{
                        list: remainingData,
                        textKey: "label",
                        valueKey: "value",
                      }}
                    />
                  </Col>
                );
              })}
            </Row>
          )}
          <Row gutter={[20, 0]} align={"top"}>
            <Col xs={24} md={12} lg={6}>
              <Button type="primary" htmlType="submit" loading={loading}>
                <SVGIcon icon="add" color="#fff" width={55} /> Add
              </Button>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <Button type="default" onClick={() => resetField()}>
                Clear
              </Button>
            </Col>
          </Row>
        </FormBox>
      </Modal>
    </>
  );
};

export default CsvUpload;
